/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { getSlotsNext } from '@fluentui/react-utilities';
/**
 * Renders a Link component by passing the state defined props to the appropriate slots.
 */ export const renderLink_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    return /*#__PURE__*/ createElement(slots.root, slotProps.root);
};
